export default "__VITE_ASSET__DXpNsaN3__"